import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import {ButtonSize} from 'ui-library/buttons/Button';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import {JSONValue} from 'util/Types';

import {EnumUISchema} from '../StepConfigEditorTypes';

interface EnumEditorProps {
  config: string | number | null;
  configShape: GetPipelineConfigSpecType<'enum'>;
  onChangeConfig: (config: JSONValue) => void;
  uiSchema?: EnumUISchema;
  disabled?: boolean;
}

export default function EnumEditor({
  config,
  configShape,
  onChangeConfig,
  uiSchema,
  disabled,
}: EnumEditorProps): JSX.Element {
  function getEnumOptionDisplayName(enumOption: string | number): string {
    return uiSchema?.displayNames?.[enumOption] ?? String(enumOption);
  }

  const placeholder = uiSchema?.placeholder ?? 'Select an option';

  return (
    <SelectDropdown
      displayName={config != null ? getEnumOptionDisplayName(config) : placeholder}
      menu={
        <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.MEDIUM}>
          {configShape.choices.map((choice) => (
            <Option<string | number>
              key={choice}
              value={choice}
              onSelect={(value) => {
                onChangeConfig(value ?? null);
              }}
            >
              {getEnumOptionDisplayName(choice)}
            </Option>
          ))}
        </Menu>
      }
      className={css(styles.grow)}
      buttonSize={ButtonSize.MEDIUM}
      disabled={disabled}
    />
  );
}

const styles = StyleSheet.create({
  grow: {
    flexGrow: 1,
  },
});
